export default function isStoreUpdate(actionType) {
	return actionType === 'STORE_UPDATED';
}
